import type { TableConfigState } from '../../table-config'

import { useCallback } from 'react'

import { useDatasheetStore, useStore } from '@/shared/lib/datasheet/store'

export const useSyncColumnsConfig = (
	setConfig: (
		id: string,
		config: Pick<
			TableConfigState,
			'columnVisibility' | 'columnPinning' | 'columnOrder' | 'columnSizing'
		>
	) => void
) => {
	const activePreset = useStore((state) => state.activePreset)
	const datasheetStore = useDatasheetStore()
	const saveUserColumnsConfig = useCallback(() => {
		if (activePreset !== '__my__') {
			return
		}
		const {
			datasheetId,
			columnVisibility,
			columnPinning,
			columnOrder,
			columnSizing,
		} = datasheetStore.getState()
		setConfig(datasheetId, {
			columnVisibility,
			columnPinning,
			columnOrder,
			columnSizing,
		})
	}, [datasheetStore, setConfig, activePreset])

	return {
		saveUserColumnsConfig,
	}
}
